import { GET_SOLICITANTES_POR_NOME } from 'services/Consulta';

const solicitante = () => {
  const getSolicitanteSelectList = async (termo) => {
    if (!termo || termo.length < 2) return [];

    const response = await GET_SOLICITANTES_POR_NOME(termo);

    return (response.value || []).map((item) => ({
      value: item.value,
      label: item.label,
    }));
  };

  return { getSolicitanteSelectList };
};

export default solicitante;
